import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Button from 'packages/ui/Button';
import { Link } from 'react-router-dom';
import Loading from 'components/Loading';
import { VirgoolsUIProvider } from './VirgoolsContextProvider';

const VirgoolsList = React.lazy(() => import('./Virgools'));

function Virgools(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>سفارش‌های ویرگول</PageTitle>
        <Button as={Link} type="anchor" to="/virgool/create/edit">
          ایجاد تبلیغ جدید
        </Button>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <VirgoolsUIProvider>
          <VirgoolsList {...props} />
        </VirgoolsUIProvider>
      </Suspense>
    </Page>
  );
}

export default Virgools;
